var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CTabs',{staticClass:"nav-tabs-boxed",attrs:{"variant":"tabs"}},[_c('CTab',{attrs:{"title":"Transportadoras"}},[_c('Transportadoras')],1),_c('CTab',{attrs:{"title":"Tipos de Frete"}},[_c('TiposFrete')],1),_c('CTab',{attrs:{"title":"Tipos de Frete X Transportadora"}},[_c('TiposFreteTransportadora')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }